module.exports = __webpack_public_path__ + "img/SC-1999.43357cc5.png";